import { render } from "./gallery-pop.vue?vue&type=template&id=79852a2d"
import script from "./gallery-pop.vue?vue&type=script&lang=js"
export * from "./gallery-pop.vue?vue&type=script&lang=js"

import "./gallery-pop.vue?vue&type=style&index=0&id=79852a2d&lang=scss"

import exportComponent from "/builds/feng.chen/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__